import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.PERSONS_SERVED_CLINICAL_REVIEW_TIME_LOG_EDIT}`,
            render: () => import("../../Pages/Core/PersonsServed/ClinicalReviewTimeLogs.svelte"),
            title: "Clinical Review Time Logs"
        }
    ]
};

export default routerConfig;